// AddConversationModal.tsx
import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface AddConversationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAdd: (scenario: string) => void;
}

export const AddConversationModal: React.FC<AddConversationModalProps> = ({
  open,
  onOpenChange,
  onAdd,
}) => {
  const [scenario, setScenario] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (scenario.trim()) {
      onAdd(scenario.trim());
      setScenario("");
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add Custom Scenario</DialogTitle>
          <DialogDescription>
            Enter a scenario description for the simulated conversation.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <Textarea
              value={scenario}
              onChange={(e) => setScenario(e.target.value)}
              placeholder="Describe the conversation scenario..."
              className="min-h-[100px]"
            />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={!scenario.trim()}>
              Add Scenario
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
